"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleResultPaginationInfiniteScroll = void 0;
const react_1 = __importDefault(require("react"));
const ExampleResultPaginationInfiniteScroll = (props) => {
    if (props.loading) {
        return (react_1.default.createElement("div", { className: "rs__pagination__infinitescroll-loading" }, "Loading..."));
    }
    return null;
};
exports.ExampleResultPaginationInfiniteScroll = ExampleResultPaginationInfiniteScroll;
//# sourceMappingURL=ExampleResultPaginationInfiniteScroll.js.map